import { render, staticRenderFns } from "./squareOnImage_v2.vue?vue&type=template&id=6be3992d&scoped=true"
import script from "./squareOnImage_v2.vue?vue&type=script&lang=js"
export * from "./squareOnImage_v2.vue?vue&type=script&lang=js"
import style0 from "./squareOnImage_v2.vue?vue&type=style&index=0&id=6be3992d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be3992d",
  null
  
)

export default component.exports